import type { GridPoint } from '../types';

export class HazardCollisionGuard {
  private activeContact?: string;
  private immunityUntil = 0;

  constructor(private readonly immunityMs = 1_800) {}

  contact(key: string, now: number): boolean {
    if (this.activeContact === key) return false;
    this.activeContact = key;
    if (now < this.immunityUntil) return false;
    this.immunityUntil = now + this.immunityMs;
    return true;
  }

  leave(): void {
    this.activeContact = undefined;
  }

  get immuneUntil(): number { return this.immunityUntil; }
}

export function recoverSafeTile(previousSafeTile: GridPoint): GridPoint {
  return { x: previousSafeTile.x, y: previousSafeTile.y };
}
